var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"shadow rounded font-display flex items-center border-2 transition hover:shadow-xl justify-center",class:_vm.classes,attrs:{"disabled":_vm.disabled || _vm.loading,"loading":_vm.loading,"icon-right":_vm.iconRight,"icon-left":_vm.iconLeft}},[_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }